<!--eslint-disable max-len-->
<template>
  <svg
    fill="none"
    height="16"
    viewBox="0 0 17 16"
    width="17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      fill="#777777"
      height="11"
      rx="5.5"
      width="11"
      x="3"
      y="2.5"
    />
    <mask
      id="mask0_24342_736"
      height="12"
      maskUnits="userSpaceOnUse"
      style="mask-type: luminance"
      width="11"
      x="3"
      y="2"
    >
      <rect
        fill="white"
        height="11"
        rx="5.5"
        width="11"
        x="3"
        y="2.5"
      />
    </mask>
    <g mask="url(#mask0_24342_736)">
      <path
        clip-rule="evenodd"
        d="M13.8658 4.23988C14.045 4.41862 14.045 4.70921 13.8658 4.88796L8.82416 9.92963C8.64541 10.1088 8.35482 10.1088 8.17607 9.92963L5.88441 7.63796C5.7052 7.45921 5.7052 7.16862 5.88441 6.98987C6.06316 6.81067 6.35374 6.81067 6.53249 6.98987L8.50011 8.9575L13.2177 4.23988C13.3965 4.06067 13.6871 4.06067 13.8658 4.23988Z"
        fill="white"
        fill-rule="evenodd"
      />
    </g>
  </svg>
</template>
